import { Helmet } from 'react-helmet-async';
import { organizationJsonLd, websiteJsonLd } from '../seoUtils';

/**
 * Sitewide Organization + WebSite JSON-LD, rendered once globally (see
 * App.js) rather than per-page - unlike SeoHead, this never touches
 * title/description/canonical, so it can't clash with a page's own SeoHead.
 */
function SiteJsonLd() {
  const jsonLd = [organizationJsonLd(), websiteJsonLd()];

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}

export default SiteJsonLd;
